import { useMemo } from 'react';
import { FILTERABLE_FIELDS, type FilterFieldConfig } from '../config/filterable-fields';
import { mapCustomPropertyDefinitionToFilterField } from '../config/custom-field-mapper';
import { useCustomFieldDefinitions } from './use-custom-field-definitions';

export const useFilterableFields = (): FilterFieldConfig[] => {
  const { data } = useCustomFieldDefinitions();

  return useMemo(() => {
    const customFields = (data?.items ?? [])
      .filter((definition) => definition.IsFilterable !== false)
      .map(mapCustomPropertyDefinitionToFilterField)
      .filter((field): field is FilterFieldConfig => field !== null);

    return [...FILTERABLE_FIELDS, ...customFields];
  }, [data?.items]);
};
